import { createStore, createTypedHooks } from 'easy-peasy'

import onboarding from './onboarding.store'

const storeModel = {
  onboarding,
}

export type StoreModel = typeof storeModel

const store = createStore(storeModel)

export type Store = typeof store

const { useStoreActions, useStoreState, useStoreDispatch, useStore } =
  createTypedHooks<StoreModel>()

export { store, useStore, useStoreActions, useStoreDispatch, useStoreState }
